import { EmptyState as BaseEmptyState, type EmptyStateProps } from "@/components/ui/EmptyState";
import { PageContainer } from "@/components/ui/Layout";
import { OrderIcon } from "@/icons";

/** Full-page empty/error state of list pages (orders, tracking); delegates to the ui `EmptyState`. */
export function EmptyState({ icon = OrderIcon, size = "page", headingLevel = 1, ...rest }: EmptyStateProps) {
  return (
    <PageContainer>
      <BaseEmptyState icon={icon} size={size} headingLevel={headingLevel} {...rest} />
    </PageContainer>
  );
}
